module.exports = __webpack_public_path__ + "static/media/ic_proyectos_ferroviario_pin.e8d98d7d.svg";